module.exports = __webpack_public_path__ + "static/media/guandao_pic4.be991848.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/guandao_pic4.jpg
 ** module id = 440
 ** module chunks = 0
 **/